import React, { useState } from "react";
import PropTypes from "prop-types";
import CookiePopup from "../../components/CookiePopup";
import EulaLink from "../../components/EulaLink";
import tcbase from "../../shim/tcbase";
import { useSystemVersion } from "../../hooks";

const RlFooter = ({ productName }) => {
  const [isBuildVersionHide, setIsBuildVersionHide] = useState(true);
  const { buildVersion, shortVersion, ticoreVersion } = useSystemVersion();
  const showBuildVersion = () => {
    setIsBuildVersionHide(false);
  };
  const { _rlapp_user: { username } = {} } = window || {};
  const isLoggedIn = !!username;

  const showReleaseNotes = event => {
    event.preventDefault();
    tcbase.showReleaseNotes();
  };

  return (
    <footer className="rlbs footer layout">
      <ul className="footer__main">
        <li className="footer__item">
          <a href="http://www.reversinglabs.com" title="ReversingLabs Website">
            ReversingLabs
          </a>
        </li>
        {isLoggedIn && (
          <li className="footer__item">
            <a href="#" onClick={showReleaseNotes} data-qa-id="release-notes">
              What's New
            </a>
          </li>
        )}
        <li className="footer__item">
          <a href="/cookie_policy" title="Cookie Policy">
            Cookie Policy
          </a>
        </li>
        <li className="footer__item">
          <a href="/privacy_policy" title="Privacy Policy">
            Privacy Policy
          </a>
        </li>
        <li>
          <EulaLink />
        </li>
      </ul>
      <div className="footer__version">
        {isLoggedIn ? (
          <span>
            <span
              onClick={showBuildVersion}
              className={`expanding-version-display ${
                buildVersion && isBuildVersionHide ? "cursor-pointer" : ""
              }`}
            >
              {productName}, {shortVersion}
              {buildVersion && (
                <span
                  className={`build-version ${
                    isBuildVersionHide ? "hide" : ""
                  }`}
                >
                  -{buildVersion}
                </span>
              )}
            </span>
            <span className="px-10">|</span>
            Spectra Core Version: {ticoreVersion}
          </span>
        ) : (
          <span>{productName}</span>
        )}
      </div>
      <CookiePopup />
    </footer>
  );
};

RlFooter.propTypes = {
  productName: PropTypes.string.isRequired
};

export default RlFooter;
